// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ca4838b","726":"56c05ec2"}[chunkId] + ".chunk.js";
};